import React from 'react';
import PropTypes from 'prop-types';
import { Routes, Route, Navigate } from 'react-router-dom';
// import WalletPrograms from '../../../WalletPrograms';
import Login from '../../../Login';
import { HOME_ROUTE, LANDING_ROUTE } from '../../../../constants/routes';
import NotFound from '../NotFound';
import { DashboardWrapper } from '../../styles';

const LandingRoute = ({ isLoggedIn }) => {
  if (isLoggedIn) {
    return <Navigate to={HOME_ROUTE} replace />;
  }
  return <Login />;
};

LandingRoute.propTypes = {
  isLoggedIn: PropTypes.bool,
};

LandingRoute.defaultProps = {
  isLoggedIn: false,
};

const RootComponent = ({
  isLoggedIn,
}) => {
  return (
    <Routes>
      <Route
        path={LANDING_ROUTE}
        element={<LandingRoute isLoggedIn={isLoggedIn} />}
      />
      <Route
        path='*'
        element={(
          <DashboardWrapper>
            <NotFound />
          </DashboardWrapper>
        )}
      />
    </Routes>
  );
};

RootComponent.propTypes = {
  isLoggedIn: PropTypes.bool,
};

RootComponent.defaultProps = {
  isLoggedIn: false,
};

export default RootComponent;
